import React from 'react'
import PropTypes from 'prop-types'
import CroppedImage from '../FrameSizeSelection/CroppedImage'

const UploadedImage = ({
  thumbnail,
  croppedArea,
  originalAreaAspect,
  croppedAreaAspect,
  noCroppingApplied = false,
}) => {
  /**
   * A memoized URL string representing the thumbnail image.
   * The URL is either retrieved via the `getPublicUrl` method if `thumbnail` is an object,
   * or defaults to an empty string if `thumbnail` is not an object.
   *
   * @constant {string} thumbnailUrl
   * @memberof React.Component
   * @param {object|string} thumbnail - The thumbnail data. It can be an object
   *                                     with a `getPublicUrl` method or a non-object value.
   * @returns {string} The public URL of the thumbnail, or an empty string if invalid.
   */
  const thumbnailUrl = React.useMemo(() => typeof thumbnail === 'object'
    ? thumbnail.getPublicUrl()
    : '', [thumbnail])

  return (
    <div>
      {noCroppingApplied
        ? (
          <img className='w-full' src={thumbnailUrl} alt={thumbnailUrl}/>
        )
        : (
          <CroppedImage
            imageSrc={thumbnailUrl}
            croppedAreaAspect={croppedAreaAspect}
            originalAreaAspect={originalAreaAspect}
            croppedArea={croppedArea}/>
        )}
    </div>
  )
}

UploadedImage.propTypes = {
  original: PropTypes.object,
  thumbnail: PropTypes.object,
  croppedAreaAspect: PropTypes.number,
  originalAreaAspect: PropTypes.number,
  croppedArea: PropTypes.object, // croppedArea is optional
  noCroppingApplied: PropTypes.bool,
}

export default UploadedImage
